import { render, staticRenderFns } from "./ClickAndBuyAdmin.vue?vue&type=template&id=31369752&scoped=true"
import script from "./ClickAndBuyAdmin.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyAdmin.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuyAdmin.vue?vue&type=style&index=0&id=31369752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31369752",
  null
  
)

export default component.exports